import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TProps, IDeps } from './models';
import { UrlMapper as Component } from './component';

/**
 * Компонент, установки URL детальной страницы оффера для дочернего виджета, используется с UrlMapperContext
 * */
export const SmePartnersCommonUrlMapper = createWidget<IDeps, TProps>({})(Component);
